import { useTranslation } from 'next-i18next';
import { getScrollPositionFromBottom, scrollToBottomOfELementById } from '../../../../utils/functions';
import { useContext, useEffect, useState } from 'react';
import { MessageContext } from '.';

export const NewMessageNotification = () => {
  const { hasNewMessage, setHasNewMessage } = useContext(MessageContext);

  const { t } = useTranslation();

  const [showNotificationButton, setShowNotificationButton] = useState(false);

  function handleClick() {
    setShowNotificationButton(false);
    scrollToBottomOfELementById('messages');
  }

  function hideNotification() {
    if (getScrollPositionFromBottom('messages') < 150) {
      setShowNotificationButton(false);
    }
  }

  useEffect(() => {
    document.getElementById('messages')?.addEventListener('scroll', hideNotification);

    return () => {
      document.getElementById('messages')?.removeEventListener('scroll', hideNotification);
    };
  }, []);

  useEffect(() => {
    if (getScrollPositionFromBottom('messages') > 150 && hasNewMessage) {
      setShowNotificationButton(true);
    }

    setHasNewMessage(false);
  }, [hasNewMessage]);

  return (
    <>
      {showNotificationButton && (
        <div className="sticky z-10 flex justify-center w-full bottom-2">
          <div className="border-2 cursor-pointer bg-slate-100 rounded-2xl border-slate-700" onClick={handleClick}>
            <p className="px-2 py-1 text-slate-700">{t('chat:new-message')}</p>
          </div>
        </div>
      )}
    </>
  );
};
